import { SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';

export module Utils {
  export const isPulseUser: () => boolean = () => {
    const state = getAppStore().getState();
    return SessionUserSelectors.canUsePulse(state);
  };
}
